<template>
  <div class="container">
    <!-- 页面标题和菜单栏 -->
    <div class="container01">
      <h1 class="container01_h1">客户管理</h1>
      <!-- 菜单栏按钮 -->
      <el-row :gutter="20">
        <el-col :span="24" class="button-col">
          <div class="container01_button">
            <el-button @click="$router.back()">返回上一级</el-button>
            <el-button type="primary" @click="handleAddCustomer">新增客户</el-button>
            <el-button type="primary" @click="handleBatchImport">批量导入</el-button>
            <el-button type="danger" @click="handleBatchDelete"
              :disabled="selectedCustomerIds.length === 0">删除选中客户</el-button>
            <el-button type="primary" @click="handleSalesCustomer">销售客户</el-button>
            <el-button type="primary" @click="handleAccountCustomer" style="margin-right: 10px;">走账客户</el-button>
          </div>
        </el-col>
      </el-row>
      <!-- 搜索栏 -->
      <el-row :gutter="20">
        <el-col :span="24" class="search-col">
          <el-input v-model="searchKeyword" placeholder="请输入客户名称或联系方式，支持模糊搜索" clearable class="container01_search"
            @keyup.enter="handleSearch"></el-input>
          <el-button type="primary" @click="handleSearch" style="margin-top: 20px;">搜索</el-button>
        </el-col>
      </el-row>
    </div>
    <!-- 信息表格 -->
    <div class="container02">
      <div>
        <el-table :data="paginatedData" border style="width: 100%" height="calc(100vh - 200px)" v-loading="loading"
          element-loading-text="加载中" v-model="selectedCustomerIds" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" />
          <el-table-column prop="customer_id" label="ID" width="55" />
          <el-table-column prop="name" label="客户名称" min-width="5%" />
          <el-table-column prop="contact" label="联系方式" min-width="5%" />
          <el-table-column prop="address" label="地址" min-width="10%" />
          <el-table-column label="操作" min-width="3%">
            <template #default="scope">
              <el-button type="text" @click="handleViewDetail(scope.row.customer_id)">详情</el-button>
              <el-button type="text" @click="handleDelete(scope.row.customer_id)"
                style="color: rgb(250,182,182);">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页按钮 -->
        <div class="pagination">
          <button @click="prevPage" :disabled="currentPage <= 1" class="page-button">上一页</button>
          <span class="page-info">当前第 {{ currentPage }} 页 / 共 {{ totalPages }} 页 - 共 {{ totalCount }} 条数据</span>
          <button @click="nextPage" :disabled="currentPage >= totalPages" class="page-button">下一页</button>
        </div>
      </div>
    </div>
    <!-- 新增客户 -->
    <el-dialog title="新增客户" v-model="addDialogVisible">
      <el-form :model="newCustomer" ref="form">
        <el-form-item label="客户名称" required>
          <el-input v-model="newCustomer.name"></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="newCustomer.contact" placeholder="选填"></el-input>
        </el-form-item>
        <el-form-item label="地址">
          <el-input v-model="newCustomer.address" placeholder="选填"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveCustomer">保存</el-button>
      </template>
    </el-dialog>
    <!-- 批量导入 -->
    <el-dialog title="批量导入" v-model="importDialogVisible">
      <div class="import-area">
        <input type="file" ref="fileInput" accept=".xlsx,.json" @change="handleFile">
        <button @click="triggerFile">选择Excel或JSON文件</button>
        <p v-if="fileName">{{ fileName }}</p>
      </div>
      <template #footer>
        <el-button @click="importDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="doImport" :disabled="!fileName">导入</el-button>
      </template>
    </el-dialog>
  </div>
</template>



<script>
import request from '@/utils/request';
import customersAPI from '@/api/customers';

export default {
  data() {
    return {
      // 原始数据
      customers: [],
      // 关键词
      searchKeyword: '',
      loading: false,
      // BaseURL: 'http://127.0.0.1:5000',
      // 页码
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      currentDB: 'sales',
      addDialogVisible: false,
      importDialogVisible: false,
      newCustomer: { name: '', contact: '', address: '' },
      fileName: '',
      file: null,
      // 复选框相关
      selectedCustomerIds: []
    }
  },
  created() {
    this.fetchCustomersData();
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalCount / this.pageSize) || 1
    },
    paginatedData() {
      return this.customers
    }
  },
  methods: {
    // 表格数据
    async fetchCustomersData() {
      this.loading = true;
      try {
        const params = {
          keyword: this.searchKeyword,
          page: this.currentPage,
          per_page: this.pageSize
        }
        // const response = await axios.get(`${this.BaseURL}/api/customers`, { params });
        // console.log(response);
        // const origin_data = response.data || {};
        const originData = await customersAPI.inquireCustomers(params);
        const customerList = Array.isArray(originData.customers) ? originData.customers : [];
        this.customers = customerList;
        this.totalCount = originData.total || 0;
        this.currentPage = originData.page || 1;
      } catch (error) {
        console.log("获取数据有误", error);
      } finally {
        this.loading = false;
      }
    },
    // 新增客户
    async saveCustomer() {
      if (!this.newCustomer.name.trim()) {
        this.$message.warning('客户名称不能为空');
        return
      }
      try {
        await customersAPI.createCustomer(this.newCustomer);
        this.$message.success('新增成功');
        this.addDialogVisible = false;
        this.newCustomer = { name: '', contact: '', address: '' };
        this.fetchCustomersData();
      } catch (err) {
        console.error('新增失败', err);
        this.$message.error('新增失败');
      }
    },
    // 批量导入
    triggerFile() {
      this.$refs.fileInput.value = ''
      this.$refs.fileInput.click();
    },
    handleFile(e) {
      const file = e.target.files[0];
      if (file) {
        const allowedTypes = ['application/json', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
        const allowedExtensions = ['.json', '.xlsx'];
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
        if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(fileExtension)) {
          this.$message.error("仅支持JSON和XLSX类型的文件");
          this.file = null;
          this.fileName = '';
          return;
        }
        this.file = file;
        this.fileName = file.name;
      }
    },
    async doImport() {
      const formData = new FormData();
      formData.append('file', this.file);
      try {
        await request.post('/api/customers/batch', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        this.$message.success('导入成功');
        this.importDialogVisible = false;
        this.fileName = '';
        this.fetchCustomersData();
        this.$refs.fileInput.value = ''
      } catch (err) {
        console.error('导入失败详情:', err.response?.data);
        this.$message.error(`导入失败: ${err.response?.data?.message || '未知错误'}`);
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchCustomersData();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.fetchCustomersData();
      }
    },
    // 实现搜索逻辑
    handleSearch() {
      this.currentPage = 1;
      this.fetchCustomersData();
    },
    // 按钮
    handleAddCustomer() {
      this.addDialogVisible = true;
    },
    handleBatchImport() {
      this.importDialogVisible = true;
    },
    // 详情页
    handleViewDetail(customerID) {
      this.$router.push(`/customers/detail/${customerID}`);
    },
    // 补充未实现的按钮方法（避免控制台警告）
    handleSalesCustomer() {
      this.$message.info('销售客户功能待实现');
    },
    handleAccountCustomer() {
      this.$message.info('走账客户功能待实现');
    },
    // 删除与批量删除
    handleSelectionChange(selectedRows) {
      // 从选中行中提取customer_id，存入selectedCustomerIds
      this.selectedCustomerIds = selectedRows.map(row => row.customer_id);
    },
    // 单个客户删除
    async handleDelete(customerId) {
      try {
        // 弹出确认弹窗
        await this.$confirm('确定要删除该客户吗？删除后数据不可恢复！', '删除确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        // 调用后端删除接口
        await customersAPI.deleteCustomer(customerId);
        this.$message.success('客户删除成功！');
        // 刷新表格数据
        this.fetchCustomersData();
      } catch (error) {
        // 取消删除时不提示错误
        if (error !== 'cancel') {
          console.error('删除失败：', error);
          this.$message.error('删除失败，请重试！');
        }
      }
    },
    // 批量删除客户
    async handleBatchDelete() {
      try {
        // 再次校验是否有选中数据（防止按钮禁用逻辑失效）
        if (this.selectedCustomerIds.length === 0) {
          this.$message.warning('请先选中要删除的客户！');
          return;
        }
        // 弹出确认弹窗
        await this.$confirm(`确定要删除选中的 ${this.selectedCustomerIds.length} 个客户吗？删除后数据不可恢复！`, '批量删除确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        // 调用后端批量删除接口
        await customersAPI.batchDeleteCustomers(this.selectedCustomerIds);
        this.$message.success('批量删除成功！');
        // 刷新表格数据 + 清空选中状态
        this.fetchCustomersData();
        this.selectedCustomerIds = [];
      } catch (error) {
        // 取消删除时不提示错误
        if (error !== 'cancel') {
          console.error('批量删除失败：', error);
          this.$message.error('批量删除失败，请重试！');
        }
      }
    },
  }
}
</script>


<style scoped>
.container01_search {
  width: 80%;
  margin-right: 10px;
  margin-top: 20px;
}

.container02 {
  width: 90%;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
}

.page-button {
  margin-left: 10px;
  margin-right: 10px;
}

.el-dialog--default {
  width: 20%;
  padding: 20px;
}

.import-area {
  padding: 20px 0;
}

.import-area input {
  display: none;
}

.import-area button {
  padding: 8px 16px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.import-area button:hover {
  background-color: #66b1ff;
}

.import-area p {
  margin-top: 10px;
  color: #606266;
}
</style>